import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {LinkConfigToCashbookContainerModel } from '../../../../../models/aggregates/cashbook/link-config-to-cashbook-container.model';

@Injectable({
  providedIn: 'root'
})
export class LinkConfigToCashbookService extends BaseApiTemplateService<LinkConfigToCashbookContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-recon-configs';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-recon-configs';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/cashbook-recon-configs';
    this.httpClient = http;
  }
}
